export default {
    routerName: '操作ログ',
    log: {
        searchName: '検索条件',
        accountName: 'アカウント',
        status: '状態',
        open: '成功',
        close: '失敗',
        createTime: '作成日付',
        createStartTime: '作成開始日付',
        createEndTime: '作成終了日付',
    },
    table: {
        id: 'ID',
        logName: 'ログネーム',
        accountName: 'アカウント',
        api: 'API',
        method: 'METHOD',
        ip: 'IP',
        msg: 'メッセージ',
        createTime: '作成日付',
        status: '状態',
    },
};
